import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FacebookOption = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FacebookOption' {...props}>
    <path fill='#3B5998' fillRule='evenodd' d='M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22' />
  </StyledIcon>
);
